module.exports = __webpack_public_path__ + "img/absoluteValuation.e6088e98.png";